import { useMemo } from "react";

const defaultCompatibleActions = ["record-create-update"];

const useAvailableActions = ({
  actions,
  compatibleActions = defaultCompatibleActions,
}) => {
  const availableActions = useMemo(() => {
    return actions
      .map((a, i) => {
        a.Index = i + 1;
        return a;
      })
      .filter(
        (a) => compatibleActions.includes(a.Type) && a.AvailableToFutureActions
      );
  }, [actions, compatibleActions]);

  return { availableActions };
};

export default useAvailableActions;
